module.exports = __webpack_public_path__ + "img/whatsapp.c2eb9b4d.svg";